import {
    TYPES,
    SAVE_ACTIVITY,
    PENDING_ACTIVITY,
    MARK_ATTENDANCE,
    IS_CHECKOUT,
    OPPORTUNITY,
    SAVE_ACCOUNT, SITE_POC_TYPE, OEM_MANUFACTURE_NAME,
    ACCOUNT_FILTER, LAST_CHECK_IN
} from "./type";

const initialState = {
    types:[],
    saveActivityResponse:[],
    pendingActivity:[],
    attendance:[],
    isCheckout:[],
    approvalPendingList:[],
    approved:[],
    opportunityTypes:[],
    saveDetails:[],
    pocTypes:[],
    eomName:[],
    accountFilter:[],
    lastCheckInRes:[]
};

const CarService = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case TYPES:
            return {
                ...state,
                types: payload,
            };
        case SAVE_ACTIVITY:
            return {
                ...state,
                saveActivityResponse: payload,
            };
        case PENDING_ACTIVITY:
            return {
                ...state,
                pendingActivity: payload,
            };
        case MARK_ATTENDANCE:
            return {
                ...state,
                attendance: payload,
            };
        case IS_CHECKOUT:
            return {
                ...state,
                isCheckout: payload,
            };
        case OPPORTUNITY:
            return {
                ...state,
                opportunityTypes: payload,
            };
        case SAVE_ACCOUNT:
            return {
                ...state,
                saveDetails: payload,
            };
        case SITE_POC_TYPE:
            return {
                ...state,
                pocTypes: payload,
            };
        case OEM_MANUFACTURE_NAME:
            return {
                ...state,
                eomName: payload,
            };

        case ACCOUNT_FILTER:
            return {
                ...state,
                accountFilter: payload,
            };
        case LAST_CHECK_IN:
            return {
                ...state,
                lastCheckInRes: payload,
            };

        default:
            return {...state};
    }
};

export default CarService;